import React from 'react';

export type AxiomLogoProps = {
  className?: string;
  height?: string;
  name?: string;
  width?: string;
};

export const AxiomLogo = ({
  className,
  height = '45px',
  name,
  width = '145px',
}: AxiomLogoProps) => {
  return (
    <svg
      className={className}
      data-test={name}
      width={width}
      height={height}
      viewBox="0 0 630 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11706_162733)">
        <g clipPath="url(#clip1_11706_162733)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M365.015 104.302C343.99 104.161 331.058 89.6299 330.863 67.8647C331.058 46.1251 343.951 31.9045 365.015 31.7442C386.037 31.9077 398.635 46.093 398.849 67.8647C398.651 89.6619 386.001 104.155 365.015 104.302ZM258.345 117.907L217.554 60.5587L258.345 4.53492V117.907ZM135.971 122.442V4.53492L176.763 64.437L135.971 122.442ZM99.6995 67.8702C99.4738 90.0905 87.716 104.13 67.399 104.302C47.7338 104.136 36.507 90.1915 36.259 67.5672C36.5038 45.6075 47.6925 31.9169 67.399 31.7442C87.7223 31.9104 99.4833 45.9952 99.7122 67.8702H99.6995ZM616.91 14.9892C608.339 5.45154 595.778 0.261911 580.578 0.277849C563.363 0.245972 548.783 8.1388 538.671 21.2244C531.457 7.96985 519.006 0.163091 501.968 0.277849C488.41 0.223658 476.817 6.09546 468.357 16.8636L468.736 2.95236H433.122V55.8464C430.645 41.6355 423.921 29.1555 414.173 19.672C401.694 7.52994 384.314 0.277849 364.767 0.277849C345.343 0.277849 327.893 7.52994 315.31 19.6656C306.027 28.6072 299.414 40.2329 296.576 53.4652V2.64633H262.503L262.506 2.63677H222.652L204.117 27.8454C202.016 30.8386 200.276 34.2973 198.976 37.2555C197.593 34.2654 195.802 30.7813 193.818 27.9123L176.169 2.63677H133.692L133.724 2.67821H99.252L99.4514 18.0877C90.7851 6.9434 77.569 -0.0664258 60.0594 4.13002e-05C43.0401 -0.00585892 27.9066 7.21754 17.168 19.2959C6.41663 31.371 0 48.2692 0 67.6028C0 87.1053 6.57166 104.141 17.3451 116.311C28.1123 128.501 43.1509 135.807 59.7651 135.804H59.8474C77.0565 135.804 90.7915 128.399 99.4482 117.43L99.2457 133.123H134.85V133.056H167.307L190.838 100.72C193.413 97.1339 195.732 92.5946 197.4 88.9893C199.14 92.5914 201.535 97.1371 204.104 100.711L227.028 133.056H260.743V133.082H296.576V82.8561C299.414 96.0883 306.027 107.714 315.31 116.659C327.893 128.794 345.343 136.047 364.767 136.047C384.314 136.047 401.694 128.794 414.173 116.646C423.921 107.166 430.645 94.6794 433.122 80.4684V133.372H468.654V62.2282C468.667 52.3048 471.113 45.2472 475.261 40.7015C479.396 36.1558 485.442 33.7267 493.732 33.7108C501.788 33.7522 506.407 35.8657 509.35 39.5188C512.314 43.1911 513.805 49.1872 513.792 57.4817V133.372H549.327V62.2282C549.327 52.3048 551.779 45.2472 555.896 40.6855C560.009 36.1398 565.976 33.7267 574.098 33.7108C582.154 33.749 586.871 35.8657 589.883 39.538C592.927 43.2325 594.462 49.2032 594.452 57.4817V133.372H630V54.5171C630 38.129 625.494 24.5206 616.91 14.9892ZM278.743 154.186C267.895 154.205 258.364 162.587 258.345 174.72C258.345 186.386 267.841 194.968 278.743 195C289.635 194.968 299.137 186.386 299.137 174.72C299.111 162.587 289.581 154.205 278.743 154.186Z"
            fill="#FF5A2D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11706_162733">
          <rect width="630" height="195" fill="white" />
        </clipPath>
        <clipPath id="clip1_11706_162733">
          <rect width="630" height="195" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
